/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Resume_Perf_Col_ApplicationsInputs */

const en_analytics_resume_perf_col_applications = /** @type {(inputs: Analytics_Resume_Perf_Col_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applications`)
};

const de_analytics_resume_perf_col_applications = /** @type {(inputs: Analytics_Resume_Perf_Col_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungen`)
};

const fr_analytics_resume_perf_col_applications = /** @type {(inputs: Analytics_Resume_Perf_Col_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidatures`)
};

const es_analytics_resume_perf_col_applications = /** @type {(inputs: Analytics_Resume_Perf_Col_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitudes`)
};

const it_analytics_resume_perf_col_applications = /** @type {(inputs: Analytics_Resume_Perf_Col_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidature`)
};

const nl_analytics_resume_perf_col_applications = /** @type {(inputs: Analytics_Resume_Perf_Col_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitaties`)
};

const pl_analytics_resume_perf_col_applications = /** @type {(inputs: Analytics_Resume_Perf_Col_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikacje`)
};

const fi_analytics_resume_perf_col_applications = /** @type {(inputs: Analytics_Resume_Perf_Col_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakemukset`)
};

const da_analytics_resume_perf_col_applications = /** @type {(inputs: Analytics_Resume_Perf_Col_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgninger`)
};

const sv_analytics_resume_perf_col_applications = /** @type {(inputs: Analytics_Resume_Perf_Col_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansökningar`)
};

/**
* | output |
* | --- |
* | "Applications" |
*
* @param {Analytics_Resume_Perf_Col_ApplicationsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_resume_perf_col_applications = /** @type {((inputs?: Analytics_Resume_Perf_Col_ApplicationsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Resume_Perf_Col_ApplicationsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_resume_perf_col_applications(inputs)
	if (locale === "fr") return fr_analytics_resume_perf_col_applications(inputs)
	if (locale === "es") return es_analytics_resume_perf_col_applications(inputs)
	if (locale === "it") return it_analytics_resume_perf_col_applications(inputs)
	if (locale === "nl") return nl_analytics_resume_perf_col_applications(inputs)
	if (locale === "pl") return pl_analytics_resume_perf_col_applications(inputs)
	if (locale === "fi") return fi_analytics_resume_perf_col_applications(inputs)
	if (locale === "da") return da_analytics_resume_perf_col_applications(inputs)
	if (locale === "sv") return sv_analytics_resume_perf_col_applications(inputs)
	return en_analytics_resume_perf_col_applications(inputs)
});